import {Component, createElement} from "react";
import {Fab} from "@material-ui/core";
import {SaveAltIcon} from "../icons";
import customTheme from "../theme";

interface SaveFabProps {
    onClick: () => void
}

export class SaveFab extends Component<SaveFabProps> {

    render() {
        return(
            <Fab color="primary" aria-label="save"
                 style={{
                     position: 'fixed',
                     bottom: customTheme.spacing(8),
                     right: customTheme.spacing(3)
                 }}
                 onClick={this.props.onClick}>
                <SaveAltIcon />
            </Fab>
        );
    }
}
